// extracted by mini-css-extract-plugin
export default {"title":"Products_title__ZpiLd","description":"Products_description__I7v4y"};